import AccessSelect from './access_select.js';

export default Vue.extend({
  components: {
    'access-select': AccessSelect,
  },

  template: `
    <div class="modal-body mt-4 mb-4">
      <div class="form-field-group">
        <div class="form-field required" :class="{ 'has-error': accessNameErrorTip }">
          <div class="form-field-head">
            <div class="form-field-title">角色名称</div>
          </div>
          <div class="form-field-input-container">
            <div class="form-field-input">
              <input type="text" placeholder="请输入角色名称" v-model.trim="accessName" class="form-field-value">
            </div>
            <div class="message" v-if="accessNameErrorTip">请输入角色名称</div>
          </div>
        </div>

        <div class="form-field required" :class="{ 'has-error': accessSelectErrorTip }">
          <div class="form-field-head">
            <div class="form-field-title">角色权限</div>
          </div>
          <div class="form-field-input-container">
            <div class="form-field-input bordered">
              <access-select :options="options"
                             :initialSelectedItems="selectedItems"
                             @valueChanged="valueChangedFunc"/>
            </div>
            <div class="message" v-if="accessSelectErrorTip">请选择角色权限</div>
          </div>
        </div>
      </div>
    </div>
  `,

  props: {
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    initialAccess: {
      type: Object,
      default() {
        return { name: '', actions: [] };
      },
    },
  },

  data() {
    return {
      selectedItems: _.filter(this.options, (option) => option._selected),
      accessName: this.initialAccess.name,
      accessSelectErrorTip: false,
      accessNameErrorTip: false,
      access: _.clone(this.initialAccess),
    };
  },

  watch: {
    accessName() {
      this.access.name = this.accessName;
      this.$emit('valueChange', this.access);
    },

    selectedItems() {
      this.access.actions = _.map(this.selectedItems, (item) => item.id);
      this.$emit('valueChange', this.access);
    },
  },

  methods: {
    valueChangedFunc(selectedItems) {
      this.selectedItems = selectedItems;
    },

    validate() {
      this.accessNameErrorTip = !this.accessName;
      this.accessSelectErrorTip = !this.selectedItems.length;
      return !(this.accessNameErrorTip || this.accessSelectErrorTip);
    },
  },
});
